import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { FiShare2 } from "react-icons/fi";
import { IoIosArrowForward } from "react-icons/io";
import CreateEventModal from "../../Modals/CreateEventModal";
import XIcon from "@mui/icons-material/X";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkIcon from "@mui/icons-material/Link";
import SendIcon from "@mui/icons-material/Send";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import axios from "axios";
import BaseUrl from "../../Components/BaseUrl";
import Cookies from "js-cookie";
import { formatInTimeZone } from 'date-fns-tz';
import { format, parse, set } from 'date-fns';
import Swal from "sweetalert2";
const Events = () => {
  const [isloading, setIsloading] = useState(false);
  const [createevent, setCreateevent] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [activeModal, setActiveModal] = useState(null);
  const [activeModal2, setActiveModal2] = useState(null);
  const modalRefs = useRef({});
  const modalRefs2 = useRef({});
  const shareButtonRefs = useRef({});
  const shareButtonRefs2 = useRef({});
  const [showShareDropdown, setShowShareDropdown] = useState(false);
  const [events, setEvents] = useState([]);
  const [recommendedEvents, setRecommendedEvents] = useState([]);
  const [activeShareDropdownIndex, setActiveShareDropdownIndex] = useState(null);
  useEffect(()=>{
    getEvents();
    getRecommendedEvents(); 
  },[])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        activeShareDropdownIndex !== null &&
        !event.target.closest(".share-container")
      ) {
        setActiveShareDropdownIndex(null);
      }
    };
  
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activeShareDropdownIndex]);
  

  const getEvents =async ()=>{
    try {
      setIsloading(true);
      const response = await axios.get(BaseUrl + "getEvents", {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      if(response.data.status === 200){
        setEvents(response.data.data.data);
        setIsloading(false);
      }
    } catch (error) {
      console.log(error);
      setIsloading(false);
    }
  }
  const getRecommendedEvents =async ()=>{
    try {
      setIsloading(true);
      const response = await axios.get(BaseUrl + "recommended", {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      if(response.data.status === 200){
        setRecommendedEvents(response.data.data.data);
        setIsloading(false);
      }
    } catch (error) {
      console.log(error);
      setIsloading(false);
    }
  }
  const formatDateTime = (startDate, startTime, endDate, endTime, timezone) => {
    try {
      const startDateTime = parse(`${startDate} ${startTime}`, 'yyyy-MM-dd HH:mm:ss', new Date());
      const endDateTime = parse(`${endDate} ${endTime}`, 'yyyy-MM-dd HH:mm:ss', new Date());
      
      const formattedStart = format(startDateTime, 'EEE, MMM d, yyyy, h:mm a');
      const formattedEnd = format(endDateTime, 'h:mm a');
      
      return `${formattedStart} - ${formattedEnd}`;
    } catch (error) {
      console.error('Error formatting date:', error);
      return 'Invalid Date';
    }
  };

  const toggleModal = (index) => {
    if (shareButtonRefs.current[index]) {
      const rect = shareButtonRefs.current[index].getBoundingClientRect();
      setActiveModal(activeModal === index ? null : index);
      modalRefs.current[index] = {
        top:  window.scrollY,
        left:  window.scrollX,
      };
    }
  };


  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (
  //       activeModal !== null &&
  //       modalRefs.current[activeModal] &&
  //       !event.target.closest(".modal-container") &&
  //       !event.target.closest(".share-button")
  //     ) {
  //       setActiveModal(null);
  //     }
  //     else if(
  //       activeModal2 !== null &&
  //       modalRefs.current[activeModal2] &&
  //       !event.target.closest(".modal-container") &&
  //       !event.target.closest(".share-button")
  //     ) {
  //       setActiveModal2(null);
  //     }
  //   };

  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, [activeModal,activeModal2]);
  const handleEventCreated = (newEvent) => {

    setEvents((prevEvents) => [newEvent, ...prevEvents].slice(0, 3));
  };
  
  const eventList = events.length > 0 ? events.slice(0, 3) : [];
    return (
      <>
        {isloading ? (
          <div className="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center z-10">
            <img src="/Images/loader.gif" className="h-16 w-16 bg-opacity-50" />
          </div>
        ) : (
          <div className="bg-[#F3F2EF] mt-14  ">
            <div className="container mx-auto flex flex-col gap-3 py-6 px-4  sm:px-6 lg:px-8">
              <div className="bg-white border border-gray-200 px-6 py-6 rounded-lg shadow w-full flex items-center justify-between">
                <p className="text-xl font-medium lg:text-4xl ">Events</p>
                <button
                  className="border border-solid border-blue-500 text-md text-blue-500   px-4 py-1 font-medium rounded-full hover:border-blue-800 hover:text-blue-800 hover:border-2 hover:font-bold"
                  onClick={() => setModalOpen(true)}
                >
                  Create an event
                </button>
              </div>

              <div className="bg-white border border-gray-200 px-6 py-6 rounded-lg shadow w-full">
                <p className="text-xl font-medium">
                  Your events{" "}
                  <span className="ml-4 text-gray-600">
                    <Link to="/events/allevents">Show all</Link>
                  </span>
                </p>
                <div className=" mt-2 grid grid-cols-3 gap-4">
                  {eventList.length > 0 ? (
                    eventList.map((event) => (
                      <div key={event.id} className="flex space-x-4">
                        {event.image ? (
                          <img
                            src={event.image || "/Images/Events/dummy-img.png"}
                            alt={event.event_name}
                            className="w-24 h-16 rounded-lg object-cover"
                          />
                        ) : (
                          <img
                            src="/Images/Events/dummy-img.png"
                            className="w-24 h-16 rounded-lg object-cover"
                          />
                        )}

                        <div className="flex flex-col items-start justify-center">
                          <p className="text-[12px] text-gray-600">
                            {formatDateTime(
                              event.start_date,
                              event.start_time,
                              event.end_date,
                              event.end_time,
                              event.timezone
                            )}
                          </p>
                          <Link
                            to={`/events/${event.slug}`}
                            className="w-56 leading-5 hover:underline"
                          >
                            {event.event_name}
                          </Link>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="text-gray-600">No events found.</p>
                  )}
                </div>
              </div>

              <div className="flex flex-col gap-4 bg-white border border-gray-200 px-6 py-6 rounded-lg shadow w-full">
                <p className="text-xl font-medium">Recommended for you</p>
                <div className="grid grid-cols-3 gap-4">
                  {recommendedEvents.map((event, index) => (
                    <div
                      key={index}
                      className="flex flex-col bg-white border border-gray-200 rounded-lg shadow w-full"
                    >
                      {event.image && (
                        <img
                          src={event.image || "/Images/Events/dummy-img.png"}
                          alt="Event"
                          className="rounded-t-lg"
                        />
                      )}
                      <div className="flex flex-col items-start p-4">
                        <p className="text-sm font-medium text-gray-600">
                          {formatDateTime(
                            event.start_date,
                            event.start_time,
                            event.end_date,
                            event.end_time,
                            event.timezone
                          )}
                        </p>
                        <p className="text-md font-bold mt-2">
                          {event.event_name}
                        </p>
                        {event.created_by_name && (
                          <div className="flex mt-2 items-center space-x-2 text-sm text-gray-600">
                            <p className="mt-1">{event.created_by_name}</p>
                            <span className="mt-1">•</span>
                            <p className="mt-1">
                              {event.attendee_count}{" "}
                              {event.attendee_count === 1
                                ? "attendee"
                                : "attendees"}
                            </p>
                          </div>
                        )}

                        <div className="flex justify-between items-center gap-2 w-full mt-3">
                          <Link
                            to={`/events/${event.slug}`}
                            className="px-4 py-2 text-blue-600 border
                            border-blue-600 rounded-full flex items-center
                            justify-center w-full hover:bg-blue-100"
                          >
                            View
                          </Link>
                          <div className="relative share-container">
                            <button
                              ref={(el) => (shareButtonRefs.current[index] = el)}
                              onClick={() =>
                                setActiveShareDropdownIndex(
                                  activeShareDropdownIndex === index ? null : index
                                )
                              }
                              className="px-2 py-2 text-blue-600 border border-blue-600 rounded-full flex items-center justify-center  hover:bg-blue-100 share-button"
                            >
                              <FiShare2 size={24} />
                            </button>

                            {activeShareDropdownIndex === index && (
                              <div
                                // ref={shareDropdownRef}
                                className="absolute bg-white border shadow-md rounded-b-md rounded-l-md mt-1 p-2 w-48 z-50"
                              >
                                <p className="font-semibold text-sm">
                                  Share on LinkedIn
                                </p>

                                <button className="text-sm text-gray-700 w-full text-left p-1 hover:bg-gray-100">
                                  <ModeEditIcon
                                    size={16}
                                    className="text-gray-700"
                                  />{" "}
                                  Repost to Feed
                                </button>
                                <button className="text-sm text-gray-700 w-full text-left p-1 hover:bg-gray-100">
                                  <SendIcon
                                    size={16}
                                    className="text-gray-700"
                                  />{" "}
                                  Send in a message
                                </button>
                                <hr className="my-1" />
                                <p className="font-semibold text-sm">
                                  Other options
                                </p>
                                <button
                                  className="flex items-center gap-1 text-sm text-gray-700 w-full text-left p-1 hover:bg-gray-100"
                                  onClick={() => {
                                    navigator.clipboard.writeText(
                                      window.location.href
                                    );

                                    Swal.fire({
                                      toast: true,
                                      position: "bottom-start",
                                      icon: "success",
                                      title: "Link copied to clipboard",
                                      showConfirmButton: false,
                                      timer: 1500,
                                      timerProgressBar: true,
                                      didOpen: (toast) => {
                                        toast.addEventListener(
                                          "mouseenter",
                                          Swal.stopTimer
                                        );
                                        toast.addEventListener(
                                          "mouseleave",
                                          Swal.resumeTimer
                                        );
                                      },
                                    });
                                    setShowShareDropdown(false);
                                  }}
                                >
                                  <LinkIcon
                                    size={16}
                                    className="text-gray-700"
                                  />{" "}
                                  Copy link
                                </button>
                                <button
                                  className="flex items-center gap-1 text-sm text-gray-700 w-full text-left p-1 hover:bg-gray-100"
                                  onClick={() => {
                                    const text =
                                      encodeURIComponent("Check this out!");
                                    const url = encodeURIComponent(
                                      window.location.href
                                    );
                                    window.open(
                                      `https://twitter.com/intent/tweet?text=${text}&url=${url}`,
                                      "_blank"
                                    );
                                    setShowShareDropdown(false);
                                  }}
                                >
                                  <XIcon size={16} className="text-gray-700" />{" "}
                                  Twitter
                                </button>
                                <button
                                  className="flex items-center gap-1 text-sm text-gray-700 w-full text-left p-1 hover:bg-gray-100"
                                  onClick={() => {
                                    const url = encodeURIComponent(
                                      window.location.href
                                    );
                                    window.open(
                                      `https://www.facebook.com/sharer/sharer.php?u=${url}`,
                                      "_blank"
                                    );
                                    setShowShareDropdown(false);
                                  }}
                                >
                                  <FacebookIcon
                                    size={16}
                                    className="text-gray-700"
                                  />{" "}
                                  Facebook
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      
                    </div>
                  ))}
                </div>
                <p className="text-center text-gray-600 cursor-pointer mt-2">
                  Show more ▼
                </p>
              </div>

              
            </div>
            <CreateEventModal
              eventmodalOpen={modalOpen}
              closeModal={() => setModalOpen(false)}
              onEventCreated={handleEventCreated}
            />
          </div>
        )}
      </>
    );
}

export default Events
